
waitAndGet = (n) ->
  startToWait        = Date.now()
  maxWaitingInterval = 5000
  pollingInterval    = 50
  _waitAndGet        = (n) ->
    if __?.slidedeck?
      n(null, __.slidedeck)
    else if Date.now() - startToWait > maxWaitingInterval
      n(new Error("timeout"))
    else
      setTimeout((-> _waitAndGet(n)), pollingInterval)
  _waitAndGet(n)

get = (n) ->
  n null, if __?.slidedeck? then __.slidedeck else {}

commands = (next) ->
  get: get
  waitAndGet: waitAndGet

module.exports = { type: "session", commands }

